import { Card, Container } from "@material-ui/core";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { UserOperatePageEvent_userOperatePageEvent_edges_node } from "../../types/UserOperatePageEvent";
import PageEventList from "../PageEventList";
import {
  createFilterStructure,
  PageEventFilterKeys,
  PageEventListFilterOpts
} from "./filters";

export interface PageEventListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<PageEventFilterKeys, PageEventListFilterOpts>,
    TabPageProps {
  pageEvent: UserOperatePageEvent_userOperatePageEvent_edges_node[];
  toatlCount: number;
}

const PageEventListPage: React.FC<PageEventListPageProps> = ({
  currencySymbol,
  filterOpts,
  initialSearch,
  currentTab,
  toatlCount,
  onAll,
  tabs,
  onFilterChange,
  onSearchChange,
  onTabChange,
  onTabSave,
  onTabDelete,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <Container>
      <PageHeader
        title={
          intl.formatMessage(sectionNames.pageEvent) + "(" + toatlCount + ")"
        }
      ></PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All PageEvents",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Currencyrate"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <PageEventList {...listProps} />
      </Card>
    </Container>
  );
};
export default PageEventListPage;
